<template>
  <loading-overlay v-if="loading" class="animated fadeIn" />
  <div v-else class="animated fadeIn">
    <default-heading class="mt-3">
      Edit Team

      <template #right>
        <b-button
          variant="info"
          class="ml-1"
          to="/team"
        >
          <i class="fal fa-eye" />
        </b-button>
      </template>
    </default-heading>

    <div v-if="customer && customer.id">
      <b-card class="mt-3">
        <customer-form-group
          :customer="customer"
          :vuelidate="$v.customer"
          @onCustomerChange="onCustomerChange"
        />
      </b-card>

      <b-alert show v-if="error" variant="danger">{{ error }}</b-alert>

      <div class="clearfix mb-5">
        <b-button
          variant="success"
          class="float-right"
          :disabled="submittingForm"
          @click="saveCustomer"
        >
          <span v-if="submittingForm">
            <i class="fa fa-circle-notch fa-spin" />
          </span>
          <span v-else>Save</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerModel from '@/models/crm/CustomerModel'
import LoadingOverlay from '@/components/shared/LoadingOverlay'
import DefaultHeading from '@/components/shared/DefaultHeading'
import CustomerFormGroup from '@/components/crm/customer/CustomerFormGroup'
import { validationMixin } from 'vuelidate/src'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'TeamEdit',
  components: {
    LoadingOverlay,
    DefaultHeading,
    CustomerFormGroup
  },
  mixins: [validationMixin],
  data () {
    return {
      authenticated_customer_id: (this.$store.getters.getAuthCustomerID || null),
      customer: null,
      loading: true,

      error: null,
      submittingForm: false
    }
  },
  validations: {
    customer: {
      full_name: { required },
      short_name: { required },
      account_number: {}
    }
  },
  mounted () {
    this.loading = true
    this.fetch().then(() => {
      this.loading = false

      this.$v.$touch()
    })
  },
  methods: {
    fetch () {
      return new Promise((resolve) => {
        if (this.authenticated_customer_id) {
          const customer = new CustomerModel({
            id: this.authenticated_customer_id
          })
          customer.fetch().then(() => {
            this.customer = customer
            resolve(this.customer)
          })
        }
      })
    },

    onCustomerChange (customer) {
      this.customer.set(customer)
    },

    saveCustomer () {
      this.$v.$touch()
      if (this.$v.$dirty && this.$v.$invalid) return

      this.submittingForm = true

      this.customer.created_at = null
      this.customer.updated_at = null

      this.customer.save().then(() => {
        this.$bvToast.toast('Thanks!', {
          title: 'Team updated successfully',
          variant: 'success',
          autoHideDelay: 1000
        })

        this.submittingForm = false
        this.$router.push('/team')
      }).catch((err) => {
        this.$bvToast.toast('There was an error updating Team', {
          title: 'Team update failed',
          variant: 'danger',
          autoHideDelay: 2000
        })

        this.submittingForm = false
      })
    }
  }
}
</script>
